import { render, staticRenderFns } from "./TkHotelAlertDander.vue?vue&type=template&id=26586dfe&"
import script from "./TkHotelAlertDander.vue?vue&type=script&lang=js&"
export * from "./TkHotelAlertDander.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports